'use strict';

var React = require('react');

var SvgTransferMajor = function SvgTransferMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 14h8v-11h-11v8h-2v-8.5a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-8.5v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5a1 1 0 0 0 0 2h2.586l-3.293 3.293a1 1 0 1 0 1.414 1.414l3.293-3.293v2.586a1 1 0 1 0 2 0v-5c0-.025 0-.05-.003-.075a1 1 0 0 0-.997-.925h-5zm-9 9.5a1.5 1.5 0 0 1 1.5-1.5h4a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-4z"
  }));
};

exports.SvgTransferMajor = SvgTransferMajor;
